import React from "react";
import { Helmet } from "react-helmet-async";
// import "../../Styles/webinar.css";

export default function WebinarPage() {
  const REDIRECT_URL =
    "https://alpha.kryzen.com/hydroponic-webinar?theme=light";

  return (
    <div className="page">
      {/* ---------------- SEO ---------------- */}
      <Helmet>
        <title>Hydroponic Webinar | Kryzen Biotech</title>
        <meta
          name="description"
          content="Join Kryzen Biotech’s Hydroponic Webinar and learn modern hydroponics, smart farming, agri automation, business planning and more. India's #1 agri webinar."
        />
        <meta
          name="keywords"
          content="hydroponic webinar, kryzen webinar, agri webinar, hydroponic farming webinar, hydroponics training, smart farming webinar, agriculture webinar india"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Hydroponic Webinar | Kryzen Biotech"
        />
        <meta
          property="og:description"
          content="Learn commercial hydroponics, farm setup, automation, and business planning directly from Kryzen Biotech experts."
        />
        <meta property="og:image" content="/images/webinar-cover.jpg" />
      </Helmet>

      {/* ---------------- HERO ---------------- */}
      <section className="py-6">
        <div className="container container-tight text-center">
          <h1 className="display-3 fw-bold">
            Hydroponic Webinar by Kryzen Biotech
          </h1>
          <p className="text-secondary fs-2 mt-2">
            India’s Most Trusted <strong>Agri Webinar</strong> for Modern
            Farming
          </p>

          <button
            className="btn btn-success btn-lg mt-3"
            onClick={() => (window.location.href = REDIRECT_URL)}
          >
            🚀 Join the Webinar
          </button>
        </div>
      </section>

      {/* ---------------- WHAT YOU LEARN ---------------- */}
      <section className="py-6 bg-light">
        <div className="container">
          <h2 className="fw-bold mb-4">What You Will Learn</h2>

          <div className="row row-cards">
            <div className="col-md-4">
              <div className="card p-4">
                <h3 className="fw-bold">Hydroponic Systems</h3>
                <p className="text-secondary">
                  NFT, DWC, Vertical Farming, greenhouse environment control.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card p-4">
                <h3 className="fw-bold">SmartFarmOS & Automation</h3>
                <p className="text-secondary">
                  AI-powered monitoring & automation for commercial farms.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card p-4">
                <h3 className="fw-bold">Business & ROI Planning</h3>
                <p className="text-secondary">
                  Costing, profitability, marketing, and commercial planning.
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              className="btn btn-success btn-lg"
              onClick={() => (window.location.href = REDIRECT_URL)}
            >
              Join Hydroponic Webinar →
            </button>
          </div>
        </div>
      </section>

      {/* ---------------- SPEAKERS ---------------- */}
      <section className="py-6">
        <div className="container">
          <h2 className="fw-bold text-center mb-4">Your Trainers</h2>

          <div className="row row-cards justify-content-center">
            <div className="col-sm-6 col-lg-4">
              <div className="card text-center p-4">
                <span
                  className="avatar avatar-xl mb-3"
                  style={{
                    backgroundImage: "url(/images/speaker1.jpg)",
                  }}
                ></span>
                <h3 className="fw-bold">Dr. Aditi Sharma</h3>
                <p className="text-secondary">
                  Hydroponics Expert & Kryzen Biotech R&D Head
                </p>
              </div>
            </div>

            <div className="col-sm-6 col-lg-4">
              <div className="card text-center p-4">
                <span
                  className="avatar avatar-xl mb-3"
                  style={{
                    backgroundImage: "url(/images/speaker2.jpg)",
                  }}
                ></span>
                <h3 className="fw-bold">Rohit Mehta</h3>
                <p className="text-secondary">
                  Certified Agri Automation Trainer
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-4">
            <button
              className="btn btn-success btn-lg"
              onClick={() => (window.location.href = REDIRECT_URL)}
            >
              Attend Kryzen Webinar →
            </button>
          </div>
        </div>
      </section>

      {/* ---------------- FINAL CTA ---------------- */}
      <section className="py-6 text-center bg-light">
        <h2 className="fw-bold">Ready to Transform Your Farming Journey?</h2>
        <p className="fs-2 text-secondary">
          Join India’s #1 <strong>Hydroponic Webinar</strong> today.
        </p>

        <button
          className="btn btn-success btn-lg"
          onClick={() => (window.location.href = REDIRECT_URL)}
        >
          Join Now →
        </button>
      </section>
    </div>
  );
}
